import { Country } from "@goodgamestudios/world-assignment";
import MovieClip = createjs.MovieClip;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
// TODO: @HTML5 unhandled GlowFilter class
// import GlowFilter = createjs.GlowFilter;
import TextField = createjs.Text;
import Container = createjs.Container;

export class CountryPickerButton extends MovieClip {
    // TODO: @HTML5 unhandled GlowFilter class
    // protected glowfilter: GlowFilter = new GlowFilter("#FFFFFF", 0.8, 16, 16, 4);
    protected glowfilter: any;

    protected background: Container;
    protected textField: TextField;
    private _minWidth: number = 100;
    public textXOffset: number = 0;	// symbolwidth+abstand/2
    protected initScale: number;

    protected mouseOverScale: number = 1.05;

    public country: Country;

    constructor() {
        // http://createjs.com/docs/easeljs/files/easeljs_display_MovieClip.js.html#l41
        super();
        this.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));
    }

    private onAddedToStage(event: Event) {
        this.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.onAddedToStage));
        this.init();
        this.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemoveToStage));
    };

    private onRemoveToStage(event: Event) {
        this.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.onRemoveToStage));
        this.removeEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOver));
        this.removeEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOut));
    };

    protected init(): void {
        this.useHandCursor = true;
        this.buttonMode = true;
        this.mouseChildren = false;
        this.tabEnabled = false;
        this.initScale = Math.min(this.scaleX, this.scaleY);
        this.addEventListener(MouseEvent.ROLL_OVER, this.bindFunction(this.onRollOver));
        this.addEventListener(MouseEvent.ROLL_OUT, this.bindFunction(this.onRollOut));
    }

    public set minWidth(value: number) {
        this._minWidth = value;
    }

    public set enableButton(value: boolean) {
        this.enabled = value;
    }

    public set selectButton(value: boolean) {
        if (value) {
            this.selected();
        }
        else {
            this.deselected();
        }
    }

    public selected(): void {
        if (this.enabled) {
            this.filters = [this.glowfilter];
        }
    }

    public deselected(): void {
        if (this.enabled) {
            this.filters = null;
        }
    }

    protected onRollOut(event: MouseEvent) {
        if (this.enabled) {
            this.scaleX = this.scaleY = this.initScale;
        }
    };

    protected onRollOver(event: MouseEvent) {
        if (this.enabled) {
            this.scaleX = this.scaleY = this.initScale * this.mouseOverScale;
        }
    };
}
